import React, { memo, useCallback } from 'react';
import { Field, useForm, useFormState } from 'react-final-form';
import WithLabel, { LABEL_STYLES } from '../../../components/with-label/WithLabel';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import WithError from '../../../components/with-error/WithError';
import { Input } from '../../../components/common-inputs';
import { PROJECT_TYPES } from '../../../constants';
import ActionsSection from '../actions-sections/ActionsSection';
import ResonanceNameFormInner from './resonance/ResonanceNameFormInner';
import SonarNameFormInner from './sonar/SonarNameFormInner';
import GenieNameFormInner from './genie/GenieNameFormInner';
import GenieGoNameFormInner from './genie-go/GenieGoNameFormInner';
import Id8NameFormInner from './id8/Id8NameFormInner';

import scss from './NameSection.module.scss';

const NameFormInner = ({ onSubmit, projectType, initialValues }) => {
  const { t } = useTranslation('projects');

  const editProject = useSelector((state) => state.projects.editProject);
  const isNameSectionLoading = useSelector((state) => state.projects.isNameSectionLoading);

  const { reset } = useForm();
  const { dirty, valid, submitting } = useFormState();

  const handleDiscardsChanges = useCallback(() => {
    reset(initialValues);
  }, [reset, initialValues]);

  return (
    <form className={scss.form} onSubmit={onSubmit}>
      <Field name='projectName' autoComplete='project-name'>
        {({ meta, input }) => (
          <WithLabel variant={LABEL_STYLES.ALIGNED} label={t('projectName')} maxWidth={360} isBold>
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              <Input
                type='text'
                size='sm'
                isError={meta.touched && meta.error}
                formProps={input}
                autoComplete='project-name'
                disabled={!editProject || isNameSectionLoading || submitting}
              />
            </WithError>
          </WithLabel>
        )}
      </Field>

      {projectType === PROJECT_TYPES.RESONANCE ? <ResonanceNameFormInner /> : null}
      {projectType === PROJECT_TYPES.SONAR ? <SonarNameFormInner /> : null}
      {projectType === PROJECT_TYPES.GENIE ? <GenieNameFormInner /> : null}
      {projectType === PROJECT_TYPES.GENIE_GO ? <GenieGoNameFormInner /> : null}
      {projectType === PROJECT_TYPES.ID8 ? <Id8NameFormInner /> : null}

      <ActionsSection
        dirty={dirty}
        valid={valid}
        onDiscard={handleDiscardsChanges}
        onSubmit={onSubmit}
        isLoading={isNameSectionLoading || submitting}
      />
    </form>
  );
};

export default memo(NameFormInner);
